/*! Thom Form - v1 - 2017-12-01
 * Copyright (c) 2017 THOM */

// jQuery.validator.unobtrusive.adapters.add('shouldbetrue', new Array(), function (
//   options
// ) {
//   options.rules['shouldbetrue'] = true
//   if (options.message) options.messages['shouldbetrue'] = options.message
// })

// jQuery.validator.addMethod('shouldbetrue', function (value, element) {
//   return jQuery(element).is(':checked')
// })
// Add client validator functionality for Checkboxes
require('jquery-form')
require('jquery-validation')
require('jquery-validation-unobtrusive')
jQuery.validator.addMethod(
  'shouldbetruemethod',
  function (value, element) {
    return $(element).is(':checked')
  },
  ''
)
jQuery.validator.unobtrusive.adapters.addBool(
  'shouldbetrue',
  'shouldbetruemethod'
);

// jQuery.validator.addMethod(
//   'shouldbetruemethod',
//   function (value, element) {
//     return $(element).is(':checked')
//   },
//   ''
// )

// jQuery.validator.unobtrusive.adapters.addBool(
//   'shouldbetrue',
//   'shouldbetruemethod'
// );

(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module unless amdModuleId is set
    define(['jquery'], function (a0) {
      return factory(a0)
    })
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory(require('jquery'))
  } else {
    factory(root['jQuery'])
  }
})(this, function ($) {
  // THOM MAP
  (function () {
    'use strict'

    /* set default variables */
    var defaults = {
      errorMsg: null,
      errorCallback: function () {},
      myCallback: function () {},
      steps: null
    }

    /* variable */
    var $inputFile = null
    var $inputFileLabel = ''
    var inputFileLabelVal = ''

    /* Plugin fn */
    function Plugin (element, options) {
      // Current select element
      this.el = element
      // Current jquery element
      this.$el = $(element)
      // select settings
      this.s = $.extend({}, defaults, options)

      // select modules
      this.modules = {}

      this.init()

      return this
    }

    /* INITIALIZE PLUGIN */
    Plugin.prototype.init = function () {
      var _this = this
      // Set Listeners
      _this.listeners()
    }

    Plugin.prototype.listeners = function () {
      var _this = this

      var formClass = _this.$el.attr('class')

      if ($('.' + formClass).exists()) {
        jQuery.validator.unobtrusive.parse('.' + formClass)
      }

      // Button click
      _this.$el.find('.thom-form__submit').click(function (e) {
        // e.preventDefault()
        $(this).prop('disabled', true)

        // Response Form
        _this.response()
      })

      // Input + Textarea keyboard button press
      _this.$el.find('input, textarea').keypress(function (e) {
        // Enter pressed?
        if (e.which == 10 || e.which == 13) {
          _this.response()
        }
      })

      if (_this.$el.find('input[type=file]').exists()) {
        $inputFile = _this.$el.find('input[type=file]')
        $inputFileLabel = $inputFile.next('label')
        inputFileLabelVal = $inputFileLabel.html()

        $inputFile.on('change', function (e) {
          var fileName = ''

          if (this.files && this.files.length > 1) {
            fileName = (
              this.getAttribute('data-multiple-caption') || ''
            ).replace('{count}', this.files.length)
          } else if (e.target.value) {
            fileName = e.target.value.split('\\').pop()
          }

          if (fileName) {
            $inputFileLabel.find('span').html(fileName)
          } else {
            $inputFileLabel.html(inputFileLabelVal)
          }
        })

        // Firefox bug fix
        $inputFile
          .on('focus', function () {
            $inputFile.addClass('has-focus')
          })
          .on('blur', function () {
            $inputFile.removeClass('has-focus')
          })
      }
    }

    Plugin.prototype.loader = function (action) {
      var _this = this
      if (action === 'show') {
        $('#spinner').addClass('show')
      }

      if (action === 'hide') {
        $('#spinner').removeClass('show')
      }
    }

    /* RESIZE */
    Plugin.prototype.resize = function () {
      var _this = this
    }

    /* Submit the form */
    Plugin.prototype.response = function () {
      var _this = this

      if (_this.$el.valid()) {
        _this.loader('show')

        var formdata = ''

        if (_this.$el.find('.mtcaptcha-verifiedtoken').length !== 0) {
          var currId = _this.$el.find('.mtcaptcha').attr('id')
          var token = mtcaptcha.getVerifiedToken(currId)
          formdata = { token: token }
        }

        _this.$el.ajaxSubmit({
          data: formdata,
          beforeSubmit: function (formData, jqForm, options) {
            // console.log('BEFORE SUBMIT')
            // serializzare, validare, etc..
          },
          success: function (responseText, statusText, xhr, $form) {
            // console.log('SUCCESS')
            _this.loader('hide')
            // console.log(responseText)
            var myStatus = responseText.Status
            var myMessage = responseText.Message
            var myTitle = responseText.Title
            var myStep = responseText.Step
            var myUrl = responseText.Url

            if (myStatus == true) {
              // console.log('status = ' + myStatus)
              if (myUrl) {
                // console.log(myUrl)
                window.location.href = myUrl
              } else if (myStep) {
                // console.log(myStep)
                _this.s.steps.thomformsteps('stepGet', myStep)
              } else {
                // console.log(myCallback)
                _this.s.myCallback(myTitle, myMessage)
              }

              // Reset form fields
              _this.clearForm()
            } else {
              // console.log('status = ' + myStatus)
              if (_this.s.errorMsg != null) {
                _this.s.errorCallback(myTitle, myMessage)
              }
            }

            // Reset form reCaptcha
            if (_this.$el.find('.thom-form-recaptcha').length != 0) {
              grecaptcha.reset(
                _this.$el.find('.thom-form-recaptcha').attr('data-widget-id')
              )
            }

            if (_this.$el.find('.mtcaptcha-verifiedtoken').length != 0) {
              var currId = _this.$el.find('.mtcaptcha').attr('id')
              mtcaptcha.resetUI(currId)
            }

            _this.$el.find('.thom-form__submit').prop('disabled', false)
          },
          dataType: 'json'
        })
      } else {
        // console.log('Form is NOT VALID')
        if (_this.s.errorMsg != null) {
          _this.s.errorCallback()
          _this.$el.find('.thom-form__submit').prop('disabled', false)
        }
      }
    }

    /* Reset the form */
    Plugin.prototype.clearForm = function () {
      var _this = this

      _this.$el.resetForm()

      if (_this.s.errorMsg != null) {
        _this.s.errorMsg.hide(0)
      }

      if (_this.$el.find('input[type=file]').exists()) {
        $inputFileLabel.html(inputFileLabelVal)
      }
    }

    // ---------------------------
    // thomForm - fn
    // ---------------------------
    $.fn.thomForm = function (options) {
      return this.each(function () {
        if (!$.data(this, 'thomForm')) {
          $.data(this, 'thomForm', new Plugin(this, options))
        } else {
          try {
            $(this)
              .data('thomForm')
              .init()
          } catch (err) {
            console.error('thomForm has not initiated properly')
          }
        }
      })
    }

    $.fn.thomForm.modules = {}
  })()
})
